import React from "react";
import ProductSideService from "./ProductSideService";
import BgImg from "../../assets/portfolio/bg2.png";
import VirtualNumber from "../../assets/product/Virtual-Number-services.png";
import OurClients from "../OurClients/OurClients";
import VirtualImageHero from "../../assets/product/virtual-number-Hero.png";
import {
  faPhoneAlt,
  faGlobe,
  faSync,
  faShieldAlt,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const VirtualPhoneNumber = () => {
  const pillars = [
    {
      title: "Global Reach",
      description:
        "Establish a virtual presence in multiple regions, enabling seamless communication across borders.",
      icon: faGlobe,
      bgColor: "bg-blue-100",
    },
    {
      title: "Call Routing & Forwarding",
      description:
        "Automatically route incoming calls to the right departments or agents, ensuring efficient handling.",
      icon: faPhoneAlt,
      bgColor: "bg-green-100",
    },
    {
      title: "Scalability & Flexibility",
      description:
        "Easily scale your communication infrastructure without the need for physical hardware.",
      icon: faSync,
      bgColor: "bg-yellow-100",
    },
    {
      title: "Privacy & Security",
      description:
        "Keep your personal and business communication secure with advanced privacy controls.",
      icon: faShieldAlt,
      bgColor: "bg-red-100",
    },
  ];
  return (
    <div>
      {/* Hero section */}
      <div className="relative bg-gradient-to-r from-[#0B0F2F] to-[#12164E] text-white py-10 px-4 md:px-8 lg:px-8 overflow-hidden">
        {/* Decorative Background Circles */}
        <div className="absolute top-[-100px] left-[-100px] w-[300px] h-[300px] bg-blue-500 opacity-30 rounded-full blur-3xl z-0" />
        <div className="absolute bottom-[-150px] right-[-100px] w-[400px] h-[400px] bg-main1  opacity-20 rounded-full blur-3xl z-0" />

        <div className="relative z-10 max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Text Content */}
          <div>
            <h1 className="text-2xl md:text-4xl lg:text-4xl font-bold leading-tight text-[#8cd3fe]">
              Virtual Phone Number
            </h1>
            <p className="md:mt-6  mt-4 text-gray-300 text-[15px] md:text-lg">
              A Virtual Phone Number enables seamless communication by routing
              calls over the internet, allowing businesses to manage customer
              interactions globally without physical phone lines. It enhances
              accessibility, improves call management, and ensures a
              professional presence, no matter the location.
            </p>
            <button className="hidden md:block mt-8 px-6 py-3 rounded-full bg-main1 hover:bg-[#1c7ed6] text-white font-medium transition">
              Know More
            </button>
          </div>

          {/* Right Image/Graphic Content */}
          <div className="flex justify-center items-center">
            <img
              src={VirtualImageHero}
              alt="virtual-number"
              className="w-full max-w-md md:max-w-md lg:max-w-md"
            />
          </div>
        </div>
      </div>
      <div className="md:py-5  py-1 ">
        <h2 className="text-xl px-2 md:px-0 md:text-3xl font-bold text-center mt-4 mb-2 text-gray-600">
          Virtual Phone Number
        </h2>
        <div className=" w-20 h-1 bg-main mx-auto md:mb-3 mb-1 rounded-full" />
        <p className="text-center md:text-base text-sm text-gray-700 px-4 md:px-20 lg:px-40">
          Effortlessly manage business calls from anywhere with a Virtual Phone
          Number. Enhance communication, maintain a local presence, and
          streamline customer interactions with seamless call routing and
          advanced features.
        </p>

        {/* Wrapper that allows scrolling */}
        <div className="px-  md:px-5 sm:px-3 grid grid-cols-1 md:grid-cols-[2fr_1fr] gap-3 sm:gap-2 md:gap-8">
          {/* Main Content */}

          <div className="container mx-auto px-4 py-8">
            <div className="grid grid-cols-1 md:grid-cols-1 gap-8">
              {/* Image Section */}

              <div className="w-full md:order-1 order-2 max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
                <img
                  src={VirtualNumber}
                  alt="Virtual-number"
                  className="w-full h-full  object-contain"
                />
              </div>

              {/* Text Content Section */}
              <div className="space-y-4 md:text-base  text-sm order-2 md:order-1 text-justify">
                <div>
                  <div className=" py-2 md:text-base text-sm">
                    <p className="text-justify">
                      <strong>Deetya Soft</strong> is a foremost virtual
                      mobile/phone number provider in Delhi NCR, India. We work
                      with innovative technologies like cloud telephony to run
                      businesses effectively, offering numbers that are
                      available in Delhi NCR, India. VMN refers to a type of
                      virtual mobile number that enables your business or
                      company to receive inbound calls from any mobile or
                      telephone user on any network globally.
                    </p>
                  </div>
                  <div className=" py-2">
                    <p className="text-justify">
                      <strong>IVR Guru</strong> provides an excellent Virtual
                      Mobile Number service in Noida, India, where you can
                      access an online interface to manage its services. This
                      solution is ideal for mid and small businesses or
                      companies with low inbound call volume needs.
                      <br />
                      SMS Marketing is a prospect we always were excited to
                      explore. We have effectively planned and delivered many
                      bulk SMS service campaigns for our customers and are
                      really eager to share it with all those who are looking
                      for an effective medium to reach out to clients within
                      seconds at prices that meet the budget. Bulk SMS has
                      proved to be a new way of communication between the sender
                      and receiver. The sender can send his message at a time to
                      multiple users. Deetya soft provides you the liberty of
                      sending SMS from anywhere, any time
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Sticky Sidebar */}
          <div className="sticky  top-20 self-start  p-3  h-fit">
            <ProductSideService />
          </div>
        </div>
      </div>

      <div
        className="py-5 px-5 relative"
        style={{
          backgroundImage: `url(${BgImg})`,
          backgroundRepeat: "repeat",
          backgroundSize: "auto",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          minHeight: "60vh",
        }}
      >
        <div className="text-center py-10 px-4">
          <h2 className="text-2xl md:text-4xl font-semibold">
            <span className="text-black">Virtual</span>
            <span className="text-sky-500"> Number </span>
          </h2>

          <div className="relative w-fit mx-auto mt-2">
            <div className="h-[1px] bg-gray-300 md:w-[150px] w-[100px] mx-auto"></div>
            <div className="absolute left-1/2 -translate-x-1/2 -top-[1px] flex gap-2">
              <div className="w-8 h-[2px] bg-sky-500"></div>
              <div className="w-8 h-[2px] bg-sky-500"></div>
            </div>
          </div>

          <p className="text-gray-500 text-base mt-4">
            What You Get Using Our Inventory Management System
          </p>
        </div>

        <div className="container mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {pillars.map((pillar, index) => (
              <div
                key={index}
                className="bg-gray-50 shadow-md  overflow-hidden hover:shadow-lg transition-shadow duration-300"
              >
                <div className="p-8 text-center">
                  <div
                    className={`w-16 h-16 flex items-center justify-center rounded-full ${pillar.bgColor} mb-4 mx-auto`}
                  >
                    <FontAwesomeIcon
                      icon={pillar.icon}
                      className="text-sky-500 text-2xl"
                    />
                  </div>
                  <h5 className="md:text-lg text-base font-semibold text-gray-800 mb-3">
                    {pillar.title}
                  </h5>
                  <p className="text-gray-600 text-sm">{pillar.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* client section */}
      <div>
        <OurClients />
      </div>
    </div>
  );
};

export default VirtualPhoneNumber;
